import { render, staticRenderFns } from "./instagram.vue?vue&type=template&id=7be40c00&scoped=true"
import script from "./instagram.vue?vue&type=script&lang=js"
export * from "./instagram.vue?vue&type=script&lang=js"
import style0 from "./instagram.vue?vue&type=style&index=0&id=7be40c00&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be40c00",
  null
  
)

export default component.exports